import { OperationType, ROUTE_PATH } from "common/constants/sm-constants";
import { MetaModel } from "common/models/utility-models/base-model";
import { GridMetaModel, Headers } from "common/models/utility-models/meta-model";
import { DocumentFilterMetaModel } from "./document-filter-meta-model";

export class DocumentReportsGridMetaModel extends GridMetaModel<Headers> {
    filterMeta = new DocumentFilterMetaModel().getMetaModel();
    constructor() {
        super(
            'Document Reports',
            ROUTE_PATH.reports,
            ROUTE_PATH.reports,
            false,
            false,
            8,
            false,
            false,
            ['orgname'],
            false,
            [],
            { isDownloadExcel: true, excelFileName: 'Document Reports_' + new Date().toLocaleDateString() +'.xlsx', btnLabel: 'Download Document Report', headers: [{ key: 'StudentName', value: 'orgname' }, { key: 'Gender', value: 'orggender' }, { key: 'Region', value: 'region' }, { key: 'State', value: 'StateName' }, { key: 'Email', value: 'orgemail' }, { key: 'Mobile', value: 'orgmobile' }, { key: 'Batch', value: 'batch_number' }, { key: 'Branch', value: 'department_name' }, { key: 'Document Name', value: 'document_name' },{ key: 'File Name', value: 'fileName' }] },
            false,
            null,
            false,
            false,
            false,
            null,
            { evalKey: 'isDeletable', evalParam: [1], decisiveParam: false },
            false,
            null,
            {
                isPreview: false,
                isPreviewType: 'VIDEO',
                isEnvUrl: false,
                linkKey: ['filePath'],
                previewName: ''
            },
            {
                isTabSwitch: false,
                label: '',
                isChecked: false
            },
            true,
            true,
            true,
            [],
            false,
            { isExtraActions: false, btnLabel: '' },
            {isCheckboxEmit: false, emitKey: '', checkedKey: '', valueKey: ''},
        )
    }

    prepareHeaderList(): Headers[] {
        const headers: Headers[] = [];
        const studentName = new Headers('Student Name', 'orgname', false, false, 'text');
        const gender = new Headers('Gender', 'orggender', false, false, 'text');
        const region = new Headers('Region', 'region', false, false, 'text');
        const state = new Headers('State', 'StateName', false, false, 'text');
        const batch = new Headers('Batch', 'batch_number', false, false, 'text');
        const branch = new Headers('Branch', 'department_name', false, false, 'text');
        const documentName = new Headers('Document Type', 'document_name', false, false, 'text');
        const fileName = new Headers('Document', 'Signedurl_fileName', false, false, 'pdf', '0', {
                    isColumnNavigation: false,
                    navigationUrl: ROUTE_PATH.dashboard,
                    navigateOperationType: OperationType.VIEW,
                    navigateTransferData: {}
                }, null, { isToggle: false, toggleKey: '', toggleCheckedValue: '', toggleUncheckedValue: '' }, true);

        headers.push(studentName);
        headers.push(gender);
        headers.push(region);
        headers.push(state);
        headers.push(branch);
        headers.push(batch);
        headers.push(documentName);
        headers.push(fileName);
        return headers;
    }

    override getMetaModel(): MetaModel {
        const pageData = new MetaModel();
        pageData.pageTitle = this.pageTitle;
        pageData.properties = this.initProperties();
        pageData.redirectPath = this.redirectPath;
        pageData['filterMeta'] = this.filterMeta;
        return pageData;
      }
}